import { Spinner } from 'dc/AcAvatar/Loader/elements';
import React from 'react';
import { ColumnsWrapper, CardWrapper } from './elements';

export function Masonry({
  cards,
  options,
}: {
  readonly cards: React.ReactElement[];
  readonly options?: { gap?: string; paddingBottom?: string };
}) {
  const columnedEvents = {
    left: [],
    right: [],
  };

  cards.forEach((card, index) => {
    if (index % 2 === 0) {
      columnedEvents.left.push(card);
    } else {
      columnedEvents.right.push(card);
    }
  });

  if (!cards) {
    <Spinner />;
  }

  return (
    <ColumnsWrapper gap={options?.gap} paddingBottom={options?.paddingBottom}>
      <CardWrapper>{columnedEvents.left}</CardWrapper>
      <CardWrapper>{columnedEvents.right}</CardWrapper>
    </ColumnsWrapper>
  );
}
